import { IonIcon } from '@ionic/react';
import Button from 'components/core/Button/Button';
import { logoLinkedin } from 'ionicons/icons';
import { useState } from 'react';
import { HStack, VStack } from 'reaction';
import LinkedInSkill, { SkillEndorsement } from 'components/portfolio/components/LinkedInSkill';
import './LinkedInSkillsSection.css';

export default function LinkedInSkillsSections() {
    const [collapsed, setCollapsed] = useState(true);

    function getClassName() {
        return `portfolio-skills-section ${collapsed ? 'collapsed' : ''}`.trim();
    }

    function getSkills() {
        return (
            <>
                <LinkedInSkill skill='Java'>
                    <MichaelWeharEndorsement />
                    <AdiRaviEndorsement />
                    <VisheshShahEndorsement />
                </LinkedInSkill>

                <LinkedInSkill skill='Full-Stack Development'>
                    <IanApplebaumEndorsement />
                    <AdiRaviEndorsement />
                    <MichaelWeharEndorsement />
                </LinkedInSkill>

                <LinkedInSkill skill='JavaScript' assessment>
                    <IanApplebaumEndorsement />
                    <AdiRaviEndorsement />
                </LinkedInSkill>

                <LinkedInSkill skill='Cascading Style Sheets (CSS)' assessment />

                <LinkedInSkill skill='Python' assessment />

                <LinkedInSkill skill='jQuery' assessment />

                <LinkedInSkill skill='OS X Development'>
                    <VisheshShahEndorsement />
                </LinkedInSkill>

                <LinkedInSkill skill='HTML' assessment />

                <LinkedInSkill skill='ReactJS' assessment>
                    <IanApplebaumEndorsement />
                </LinkedInSkill>

                <LinkedInSkill skill='Webpack'>
                    <IanApplebaumEndorsement />
                </LinkedInSkill>

                <LinkedInSkill skill='Git' assessment />
            </>
        );
    }

    return (
        <VStack justify='start' className={getClassName()}>
            <HStack>
                <IonIcon icon={logoLinkedin} size='large' />
                &nbsp;
                <h2>Skills</h2>
            </HStack>

            <VStack className='skills-list' justify='start'>
                {getSkills()}
            </VStack>

            <Button onClick={() => void setCollapsed(false)} className='show-more-button'>
                Show More Skills
            </Button>
        </VStack>
    );
}

function MichaelWeharEndorsement() {
    return (
        <SkillEndorsement
            name='Michael Wehar'
            occupation='Professor'
            organization='Swarthmore College'
            highlySkilled
        />
    );
}

function AdiRaviEndorsement() {
    return <SkillEndorsement name='Adi Ravi' occupation='Advisory Associate' organization='KPMG' />;
}

function VisheshShahEndorsement() {
    return (
        <SkillEndorsement
            name='Vishesh Shah'
            occupation='Student'
            organization='University of Pennsylvania'
        />
    );
}

function IanApplebaumEndorsement() {
    return (
        <SkillEndorsement
            name='Ian Applebaum'
            occupation='Software Design Engineer'
            organization='Electric Bluefish Productions'
        />
    );
}
